module.exports = __webpack_public_path__ + "static/media/team-member-02.4c84472e.jpg";